module.exports = __webpack_public_path__ + "img/40.958ac389.svg";